import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";

const styles = theme => ({
  tooltipOverride: {
    background: "#5c5c5c",
    borderRadius: 0,
    fontSize: theme.typography.pxToRem(14),
    overflowWrap: "break-word",
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    whiteSpace: "pre-wrap",
    maxWidth: 300,
    maxHeight: "85vh",
    overflow: "scroll",
    marginLeft: -theme.spacing(1) * 2,
    wordBreak: "break-word",
    wordWrap: "break-word",
    "& *": {
      color: theme.palette.common.white
    }
  },
  tooltipPopperOverride: {
    opacity: 1
  },
  tooltipWrapper: {
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
});

const OSSTooltip = ({ children, classes, title, ...rest }) => (
  <Tooltip
    enterDelay={500}
    placement="bottom-start"
    classes={{
      tooltip: classes.tooltipOverride,
      popper: classes.tooltipPopperOverride
    }}
    title={title}
    {...rest}
  >
    <span className={classes.tooltipWrapper}>{children}</span>
  </Tooltip>
);

export default withStyles(styles)(OSSTooltip);
